angular.module('am4').controller('forgotResetCtrl', function(jwtHelper, $stateParams, $state, forgotPassword, $log, safeLogsService) {
    var that = this,
        token,
        expired;

    try {
        token = jwtHelper.decodeToken($stateParams.token);
        expired = (new Date().getTime() / 1000) - token.exp > 0;
    } catch (e) {
        $log.error('FORGOT_RESET_TOKEN_INVALID_ERROR', {
            token: $stateParams.token,
            jwtDecoderError: e
        });

        return $state.go('^.invalid');
    }

    that.email = token.email;

    if (expired) {
        return $state.go('^.expired', {
            email: that.email
        });
    }


    that.submit = function(password) {
        that.loading = true;

        forgotPassword.reset($stateParams.token, password)
        .then(function() {
            $state.go('^.success', {
                email: that.email
            });
        })
        .catch(function(e) {
            safeLogsService.log('FORGOT_RESET_ERROR', e);

            $state.go('^.error', {
                email: that.email
            });
        });
    };
});



// WEBPACK FOOTER //
// ./src/app/controllers/forgotResetCtrl.js